<section id="collections" class="section collections">
  <div class="container">
    <header class="section-head" appReveal>
      <p class="eyebrow">Collections</p>
      <h2 class="title">A recliner for <em>every</em> room</h2>
      <p class="lead">
        For the stories, smiles and snuggles — make your living room the most loved room in the house, or bring the
        cinema home.
      </p>
    </header>

    <div class="tabs" role="tablist" aria-label="Recliner categories" appReveal>
      @for (tab of tabs; track tab.id; let i = $index) {
        <button
          type="button"
          class="tab"
          role="tab"
          id="range-tab-{{ tab.id }}"
          [class.is-active]="i === active()"
          [attr.aria-selected]="i === active()"
          [attr.aria-controls]="'range-panel-' + tab.id"
          [attr.tabindex]="i === active() ? 0 : -1"
          (click)="select(i)"
          (keydown)="onKey($event, i)"
        >
          {{ tab.label }}
        </button>
      }
    </div>

    @for (tab of tabs; track tab.id; let i = $index) {
      <div
        class="panel"
        role="tabpanel"
        id="range-panel-{{ tab.id }}"
        [class.is-active]="i === active()"
        [attr.aria-labelledby]="'range-tab-' + tab.id"
        [attr.hidden]="i === active() ? null : ''"
        tabindex="0"
      >
        @if (tab.banner; as banner) {
          <div class="banner">
            <img class="banner__img" [src]="banner.image" [alt]="banner.alt" loading="lazy" decoding="async" />
            <div class="banner__text">
              <h3 class="banner__title">{{ banner.title }}</h3>
              <p>{{ banner.text }}</p>
              <ul class="banner__points">
                @for (point of banner.points; track point) {
                  <li>{{ point }}</li>
                }
              </ul>
              <a class="btn btn--primary" href="#enquire">
                Enquire now
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6" /></svg>
              </a>
            </div>
          </div>
        } @else if (tab.feature; as item) {
          <ul class="cards">
            <li class="feature" [style.--i]="0">
              <a class="feature__link" [href]="item.href" target="_blank" rel="noopener">
                <div class="feature__pic">
                  <figure
                    class="feature__media"
                    [class.feature__media--cutout]="item.cutout"
                    [class.is-blended]="item.cutout && !item.backdrop"
                    [style.background]="item.backdrop"
                  >
                    <img [src]="item.image" [alt]="item.alt" loading="lazy" decoding="async" />
                    @if (item.off) {
                      <span class="off">{{ item.off }}</span>
                    }
                  </figure>

                  <p class="feature__fans">
                    <span class="faces">
                      @for (face of fans.faces; track face) {
                        <img [src]="face" alt="" width="44" height="44" loading="lazy" decoding="async" />
                      }
                      <span class="faces__count">{{ fans.count }}</span>
                    </span>
                    <span class="feature__fans-label">{{ fans.label }}</span>
                  </p>
                </div>

                <div class="feature__foot">
                  <h3 class="feature__name">{{ item.name }}</h3>
                  <ng-container [ngTemplateOutlet]="starsTpl" [ngTemplateOutletContext]="{ $implicit: item.rating }" />
                  @if (item.price) {
                    <p class="feature__end feature__price">
                      <strong>{{ item.price }}</strong>
                      <s>{{ item.mrp }}</s>
                    </p>
                  } @else {
                    <p class="feature__end feature__text">{{ item.text }}</p>
                  }
                </div>

                <ng-container [ngTemplateOutlet]="bayTpl" />
              </a>
            </li>

            @for (item of tab.side; track item.name; let k = $index) {
              <li class="mini" [style.--i]="k + 1">
                <a class="mini__link" [href]="item.href" target="_blank" rel="noopener">
                  <figure class="mini__media" [class.mini__media--cutout]="item.cutout" [style.background]="item.backdrop">
                    <img [src]="item.image" [alt]="item.alt" loading="lazy" decoding="async" />
                    @if (item.colours; as colours) {
                      <span class="mini__colours" aria-hidden="true">
                        @for (colour of colours; track colour) {
                          <span [style.background]="colour"></span>
                        }
                      </span>
                    }
                    @if (item.off) {
                      <span class="off">{{ item.off }}</span>
                    }
                  </figure>
                  <div class="mini__body">
                    <h3 class="mini__name">{{ item.name }}</h3>
                    <ng-container [ngTemplateOutlet]="starsTpl" [ngTemplateOutletContext]="{ $implicit: item.rating }" />
                    @if (item.price) {
                      <p class="mini__end mini__price">
                        <strong>{{ item.price }}</strong>
                        <s>{{ item.mrp }}</s>
                      </p>
                    } @else {
                      <p class="mini__end type">{{ item.type }}</p>
                    }
                  </div>
                  <ng-container [ngTemplateOutlet]="bayTpl" />
                </a>
              </li>
            }
          </ul>
        }

        <a class="link-arrow panel__more" [href]="tab.more.href" target="_blank" rel="noopener">
          {{ tab.more.label }}
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6" /></svg>
        </a>
      </div>
    }
  </div>
</section>

<!-- the stars out of five, and the number of reviews, when the model has any -->
<ng-template #starsTpl let-rating>
  @if (rating) {
    <p class="rating">
      <span class="rating__stars" aria-hidden="true">
        @for (star of stars; track star) {
          <svg viewBox="0 0 24 24" [class.is-on]="star <= rating.stars"><path d="m12 2.6 2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.5l-5.9 3.1 1.2-6.5-4.8-4.6 6.6-.9z" /></svg>
        }
      </span>
      <span class="rating__count">({{ rating.reviews }})</span>
      <span class="sr-only">Rated {{ rating.stars }} out of 5 by {{ rating.reviews }} {{ rating.reviews === 1 ? 'customer' : 'customers' }}</span>
    </p>
  }
</ng-template>

<!-- the corner cut out of a card, with the round arrow button in it (as on the Best Sellers cards) -->
<ng-template #bayTpl>
  <span class="bay" aria-hidden="true">
    <span class="go">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 17 17 7M9 7h8v8" /></svg>
    </span>
  </span>
</ng-template>
